import styled from 'styled-components';
import Form from 'components/form';
import { ReactComponent as CloseIcon } from 'styles/icons/close-circle-filled.svg';
import { normalize } from 'utils/styles';
import { ReactComponent as SearchIcon } from 'styles/icons/search.svg';

export const Input = styled(Form.TextInput)`
  height: 50px;
`;

export const Close = styled(CloseIcon)`
  cursor: pointer;
  height: ${normalize('18px')};
  width: ${normalize('18px')};
`;

export const Search = styled(SearchIcon)`
  cursor: pointer;
  height: ${normalize('18px')};
  width: ${normalize('18px')};
  margin-right: 10px;
`;
